export const companyList = (state) => state.companyList;

export const companyFilterList = (state) => state.companyFilterList;

export const company = (state) => state.company;

export const companyBalance = (state) => state.company.balance;
